<main
  class="installment-plans-component"
  [class.desktop]="!(lessThan$ | async)?.sm"
  [class.single-header]="!(lessThan$ | async)?.mobileXL"
  *transloco="let t">
  <div class="wrapper scroll" id="mainAppScroll">
    <div class="content">
      <div class="header">
        <img class="image-banner" src="/assets/banners/installment-plans.png" />
      </div>
      <article class="content-wrapper">
        <section>
          @if (lang !== 'AR') {
            <h1>Advantages of financing your purchase</h1>
            <span
              >Popsy provides you with device installment service in collaboration with
              Quara Finance, Baseeta Tabby and Tamara. We enable you to purchase devices
              and pay in easy monthly installments of your choice.
            </span>
            <span class="fixed-space-8" aria-hidden="true"></span>

            <span
              >Get your device and pay in up to 36 months Immediate approval Financing
              options from 200 SAR up to 30,000 SAR Without a guarantor Sharia-compliant
            </span>
            <span class="fixed-space-32" aria-hidden="true"></span>

            <span>See below Financing services available and eligibility. </span>
          } @else {
            <h1>مزايا تمويل الشراء الخاص بك</h1>
            <span>
              توفر لك Popsy خدمة تقسيط الجهاز الجديد بالتعاون مع Quara Finance و Baseeta
              Tabby و Tamara. نحن نمكنك من شراء الأجهزة والدفع على أقساط شهرية بطرق سهلة
              ومريحة من اختيارك.
            </span>
            <span class="fixed-space-8" aria-hidden="true"></span>

            <span
              >احصل على جهازك وادفع في بالتقسيط على 36 شهرًا الموافقة الفورية خيارات
              التمويل من 200 ريال سعودي حتى 30000 ريال سعودي من دون كفيل الامتثال للشريعة
            </span>
            <span class="fixed-space-32" aria-hidden="true"></span>

            <span
              >انظر أدناه للتعرف أكثر على خدمات التمويل المتاحة والأهلية التي تخولك
              الإستفادة منها.</span
            >
          }

          <span class="fixed-space-32" aria-hidden="true"></span>

          <!-- BASEETA -->
          @if (displayBaseeta() === true) {
            <div
              class="popsy-card option-card"
              [class.selected]="selectedTab() === 'baseeta'">
              @if (lang !== 'AR') {
                <div
                  class="cursor-pointer"
                  (click)="
                    selectedTab() === 'baseeta'
                      ? selectedTab.set(null)
                      : selectedTab.set('baseeta')
                  ">
                  <div class="flex align-center justify-between">
                    <div class="flex align-center">
                      <popsy-checkbox
                        [checked]="selectedTab() === 'baseeta'"
                        class="tabby"></popsy-checkbox>

                      <h1>Baseeta</h1>
                    </div>
                    <popsy-icon-baseeta-badge-en
                      class="icon provider"></popsy-icon-baseeta-badge-en>
                  </div>
                  <div
                    class="flex"
                    [class.flex-col]="(lessThan$ | async)?.mobileL === true"
                    [class.gap-4]="(lessThan$ | async)?.mobileL === true"
                    [class.gap-16]="!(lessThan$ | async)?.mobileL === true">
                    <span class="text-gray-05">From 6 to 36 months </span>
                    <span class="text-gray-05">No down payment </span>

                    <span class="text-gray-05">From 100 SAR up to 30,000 SAR </span>
                  </div>
                  <span class="fixed-space-8" aria-hidden="true"></span>
                </div>
              } @else {
                <div
                  class="cursor-pointer"
                  (click)="
                    selectedTab() === 'baseeta'
                      ? selectedTab.set(null)
                      : selectedTab.set('baseeta')
                  ">
                  <div class="flex align-center justify-between">
                    <div class="flex align-center">
                      <popsy-checkbox
                        [checked]="selectedTab() === 'baseeta'"
                        class="tabby"></popsy-checkbox>

                      <h1>الدفع عن طريق كوارا</h1>
                    </div>
                    <popsy-icon-baseeta-badge-ar
                      class="icon provider"></popsy-icon-baseeta-badge-ar>
                  </div>
                  <div
                    class="flex"
                    [class.flex-col]="(lessThan$ | async)?.mobileL === true"
                    [class.gap-4]="(lessThan$ | async)?.mobileL === true"
                    [class.gap-16]="!(lessThan$ | async)?.mobileL === true">
                    <span class="text-gray-05">من 6 إلى 36 شهرًا</span>
                    <span class="text-gray-05">لا يوجد دفعة أولى </span>

                    <span class="text-gray-05"
                      >من 100 ريال سعودي إلى 30000 ريال سعودي</span
                    >
                  </div>
                  <span class="fixed-space-8" aria-hidden="true"></span>
                </div>
              }

              @if (selectedTab() === 'baseeta') {
                <div class="card-content">
                  @if (lang !== 'AR') {
                    <h3>How to buy with Baseeta</h3>
                    <div class="flex flex-col">
                      <span>1. Set up your Baseeta Account </span>
                      <span>2. Choose Baseeta as your payment method </span>
                      <span>3. Authenticate the payment with Baseeta App </span>
                      <span>4. Confirm and complete your transaction </span>
                      <span>5. Check your transaction history </span>
                    </div>
                  } @else {
                    <h3>كيف يتم الشراء مع بسيطة:</h3>
                    <div class="flex flex-col">
                      <span>قم بإعداد حساب بسيطة الخاص بك </span>
                      <span>اختر بسيطة كطريقة دفع </span>
                      <span>قم بالتحقق من الدفع باستخدام تطبيق بسيطة </span>
                      <span>قم بتأكيد المعاملة وإكمالها </span>
                      <span>تحقق من سجل المعاملات الخاص بك </span>
                    </div>
                  }

                  <span class="fixed-space-16" aria-hidden="true"></span>

                  @if (lang !== 'AR') {
                    <h3>Eligibility</h3>

                    <span class="fixed-space-8" aria-hidden="true"></span>

                    <div
                      class="eligibility-grid"
                      [class.mobile]="(lessThan$ | async)?.mobileL === true">
                      <span class="bold">Age</span>
                      <span class="bold"> Eligibility </span>
                      <span class="bold">Work Eligibility </span>
                      <span class="bold">Minimum Salary </span>

                      <span>Below 18 years</span>
                      <span>Not eligible</span>
                      <span></span>
                      <span></span>

                      <span>18 - 21 years </span>
                      <span>Not eligible</span>
                      <span></span>
                      <span></span>

                      <span>21+ years </span>
                      <span>Eligible </span>
                      <span>Min. 3 months for Saudis </span>
                      <span>SAR 4500 </span>

                      <span>21+ years </span>
                      <span>Eligible </span>
                      <span>Min. 12 months for expats </span>
                      <span>SAR 4500 </span>

                      <span>Retiree up to the age of 65 </span>
                      <span>Eligible </span>
                      <span>For Saudis </span>
                      <span> </span>

                      <span>Retiree up to the age of 65 </span>
                      <span>Eligible </span>
                      <span>For expats </span>
                      <span> </span>
                    </div>
                  } @else {
                    <h3>الأهلية</h3>
                    <span class="fixed-space-8" aria-hidden="true"></span>

                    <div
                      class="eligibility-grid"
                      [class.mobile]="(lessThan$ | async)?.mobileL === true">
                      <span class="bold"> العمر</span>
                      <span class="bold"> الأهلية </span>
                      <span class="bold"> أهلية العمل </span>
                      <span class="bold"> الحد الأدنى للراتب </span>

                      <span>دون سن ال 18 </span>
                      <span>غير مؤهل </span>
                      <span></span>
                      <span></span>

                      <span>من 18 الى 21 </span>
                      <span>غير مؤهل </span>
                      <span></span>
                      <span></span>

                      <span>فوق ال 21 </span>
                      <span>مؤهل </span>
                      <span>الحد الأدنى 3 أشهر للسعوديين </span>
                      <span>SAR 4500 </span>

                      <span>فوق ال 21 </span>
                      <span>مؤهل</span>
                      <span>الحد الأدنى 12 شهرًا للمغتربين </span>
                      <span>SAR 4500 </span>

                      <span>متقاعد حتى سن 65 عامًا</span>
                      <span>مؤهل</span>
                      <span>للسعوديين</span>
                      <span></span>

                      <span>متقاعد حتى سن 65 عامًا</span>
                      <span>مؤهل</span>
                      <span>للمغتربين </span>
                      <span></span>
                    </div>
                  }

                  <span class="fixed-space-16" aria-hidden="true"></span>

                  @if (lang !== 'AR') {
                    <h3>Requirements</h3>
                    <span
                      >When registering at Baseeta for the first time you will need to
                      provide:
                    </span>
                    <div class="flex flex-col">
                      <span>Valid mobile phone number</span>
                      <span> Copy of your national ID/Iqama </span>
                      <span>GOSI or Salary certificate </span>
                      <span>Proof of address </span>
                      <span>Valid email address </span>
                      <span
                        >Some cases they might require a 3 months bank statement
                      </span>
                    </div>
                  } @else {
                    <h3>المستندات المطلوبة:</h3>
                    <span>عند التسجيل في بسيطة لأول مرة، ستحتاج إلى تقديم: </span>
                    <div class="flex flex-col">
                      <span>رقم هاتف محمول صالح </span>
                      <span>نسخة صالحة من بطاقة الهوية الوطنية/الإقامة </span>
                      <span>شهادة التأمينات الاجتماعية أو شهادة الراتب </span>
                      <span>إثبات العنوان </span>
                      <span>عنوان بريد إلكتروني صالح </span>
                      <span>في بعض الحالات قد يطلبون كشف حساب بنكي لمدة 3 أشهر</span>
                    </div>
                  }

                  <span class="fixed-space-16" aria-hidden="true"></span>

                  <div class="faq">
                    @if (lang !== 'AR') {
                      <h3>FAQ</h3>
                    } @else {
                      <h3>الأسئلة الشائعة</h3>
                    }

                    @for (item of baseetaFaqData; track item; let i = $index) {
                      @if (
                        (lang !== 'AR' && item.question.length) ||
                        (lang === 'AR' && item.questionAr.length)
                      ) {
                        <div class="item">
                          <div class="question" (click)="item.open = !item.open">
                            @if (lang !== 'AR') {
                              <span>{{ item.question }}</span>
                            }
                            @if (lang === 'AR') {
                              <span>{{ item.questionAr }}</span>
                            }
                            <span class="fixed-space-8" aria-hidden="true"></span>
                            <popsy-icon-chevron-down
                              class="icon icon fill-gray-01"
                              [class.selected]="item.open" />
                          </div>
                          @if (lang !== 'AR') {
                            <div
                              class="answer"
                              [class.selected]="item.open"
                              [innerHTML]="item.answer"></div>
                          }
                          @if (lang === 'AR') {
                            <div
                              class="answer"
                              [class.selected]="item.open"
                              [innerHTML]="item.answerAr"></div>
                          }
                          @if (i === 1 && item.open) {}
                          <span class="line fill-row"></span>
                        </div>
                      }
                    }
                  </div>
                </div>
              }
            </div>
          }

          <span class="fixed-space-16" aria-hidden="true"></span>

          <!-- TAMARA -->
          <div
            class="popsy-card option-card"
            [class.selected]="selectedTab() === 'tamara'">
            @if (lang !== 'AR') {
              <div
                class="cursor-pointer"
                (click)="
                  selectedTab() === 'tamara'
                    ? selectedTab.set(null)
                    : selectedTab.set('tamara')
                ">
                <div class="flex align-center justify-between">
                  <div class="flex align-center">
                    <popsy-checkbox
                      [checked]="selectedTab() === 'tamara'"
                      class="tabby"></popsy-checkbox>

                    <h1>Tamara</h1>
                  </div>
                  <popsy-icon-tamara class="icon provider"></popsy-icon-tamara>
                </div>
                <div
                  class="flex"
                  [class.flex-col]="(lessThan$ | async)?.mobileL === true"
                  [class.gap-4]="(lessThan$ | async)?.mobileL === true"
                  [class.gap-16]="!(lessThan$ | async)?.mobileL === true">
                  <span class="text-gray-05">Up to 6 installments </span>
                  <span class="text-gray-05"> A down payment of 25% </span>
                  <span class="text-gray-05"> From 200 SAR to 5,000 SAR </span>
                </div>
                <span class="fixed-space-8" aria-hidden="true"></span>
              </div>
            } @else {
              <div
                class="cursor-pointer"
                (click)="
                  selectedTab() === 'tamara'
                    ? selectedTab.set(null)
                    : selectedTab.set('tamara')
                ">
                <div class="flex align-center justify-between">
                  <div class="flex align-center">
                    <popsy-checkbox
                      [checked]="selectedTab() === 'tamara'"
                      class="tabby"></popsy-checkbox>

                    <h1>تمارا</h1>
                  </div>
                  <popsy-icon-tamara-ar class="icon provider"></popsy-icon-tamara-ar>
                </div>
                <div
                  class="flex"
                  [class.flex-col]="(lessThan$ | async)?.mobileL === true"
                  [class.gap-4]="(lessThan$ | async)?.mobileL === true"
                  [class.gap-16]="!(lessThan$ | async)?.mobileL === true">
                  <span class="text-gray-05">حتى 6 أقساط </span>
                  <span class="text-gray-05">دفعة أولى بنسبة 25% </span>
                  <span class="text-gray-05">من 200 ريال سعودي إلى 5000 ريال سعودي </span>
                </div>
                <span class="fixed-space-8" aria-hidden="true"></span>
              </div>
            }

            @if (selectedTab() === 'tamara') {
              <div class="card-content">
                @if (lang !== 'AR') {
                  <span
                    >Tamara is a buy-now-pay-later fintech with the ultimate goal of
                    giving everyone the chance to shop without worrying about big
                    payments, hidden fees or interest.
                  </span>
                } @else {
                  <span>
                    تمارا هي تقنية دفع للشراء الآن والدفع لاحقًا بهدف نهائي وهو منح الجميع
                    فرصة التسوق من دون القلق بشأن المدفوعات الكبيرة أو الرسوم الخفيّة أو
                    الفائدة.
                  </span>
                }

                <span class="fixed-space-16" aria-hidden="true"></span>

                @if (lang !== 'AR') {
                  <h3>How to buy with Tamara</h3>
                  <div class="flex flex-col">
                    <span>1. Select Tamara as your payment method </span>
                    <span>2. Log in or sign up with your mobile number </span>
                    <span>Verify your ID if it’s your first order with Tamara </span>
                    <span
                      >4. Complete your first payment to make your first purchase and pay
                      the rest over time
                    </span>
                  </div>
                } @else {
                  <h3>كيفية الشراء مع تمارا</h3>
                  <div class="flex flex-col">
                    <span>حدد تمارا كطريقة الدفع الخاصة بك </span>
                    <span
                      >قم بتسجيل الدخول أو إنشاء حساب باستخدام رقم هاتفك المحمول
                    </span>
                    <span
                      >تحقق من ملفك الشخصي وهوية التعريف الخاصة بك إذا كان هذا طلبك الأول
                      مع تمارا</span
                    >
                    <span
                      >أكمل الدفعة الأولى لإجراء أول عملية شراء لك وادفع الباقي بمرور
                      الوقت
                    </span>
                  </div>
                }

                <span class="fixed-space-16" aria-hidden="true"></span>

                @if (lang !== 'AR') {
                  <h3>Eligibility</h3>

                  <span class="fixed-space-8" aria-hidden="true"></span>

                  <div
                    class="eligibility-grid"
                    [class.mobile]="(lessThan$ | async)?.mobileL === true">
                    <span class="bold">Age</span>
                    <span class="bold"> Eligibility </span>
                    <span class="bold">Minimum loan value </span>
                    <span class="bold">Maximum loan value </span>

                    <span>Below 18 years</span>
                    <span>Not eligible</span>
                    <span></span>
                    <span></span>

                    <span> 18 - 21 years </span>
                    <span>Eligible</span>
                    <span>SAR 200</span>
                    <span>SAR 1,500</span>

                    <span> Above 21 years </span>
                    <span> Eligible </span>
                    <span> SAR 200 </span>
                    <span> SAR 5,000 </span>
                  </div>
                } @else {
                  <h3>الأهلية</h3>
                  <span class="fixed-space-8" aria-hidden="true"></span>

                  <div
                    class="eligibility-grid"
                    [class.mobile]="(lessThan$ | async)?.mobileL === true">
                    <span class="bold"> العمر</span>
                    <span class="bold"> الأهلية </span>
                    <span class="bold"> الحد الأدنى للقرض </span>
                    <span class="bold"> الحد الأقصى للقرض </span>

                    <span>ما دون 18 سنة </span>
                    <span>غير مؤهل </span>
                    <span></span>
                    <span></span>

                    <span> 18 - 21 سنة </span>
                    <span>مؤهل</span>
                    <span>200 ريال سعودي</span>
                    <span>1500 ريال سعودي</span>

                    <span> فوق 21 سنة </span>
                    <span>مؤهل</span>
                    <span>200 ريال سعودي</span>
                    <span>5000 ريال سعودي</span>
                  </div>
                }

                <span class="fixed-space-16" aria-hidden="true"></span>

                @if (lang !== 'AR') {
                  <h3>Requirements</h3>
                  <span
                    >When registering at Tamara for the first time you will need to
                    provide:
                  </span>
                  <div class="flex flex-col">
                    <span>Valid mobile phone number</span>
                    <span> Copy of your national ID</span>
                    <span>Valid debit or credit card</span>
                  </div>
                } @else {
                  <h3>الشروط والمستندات المطلوبة:</h3>
                  <span
                    >عند تسجيل الدخول للمرة الأولى مع تمارا سوف تحتاج إلى تقديم ما يلي:
                  </span>
                  <div class="flex flex-col">
                    <span>رقم هاتف محمول صالح </span>
                    <span>صورة عن هوية التعريف الشخصية </span>
                    <span>بطاقة دفع أو ائتمان صالحة للإستخدام </span>
                  </div>
                }

                <span class="fixed-space-16" aria-hidden="true"></span>

                <div class="faq">
                  @if (lang !== 'AR') {
                    <h3>FAQ</h3>
                  } @else {
                    <h3>الأسئلة الشائعة</h3>
                  }

                  @for (item of tamaraFaqData; track item; let i = $index) {
                    @if (
                      (lang !== 'AR' && item.question.length) ||
                      (lang === 'AR' && item.questionAr.length)
                    ) {
                      <div class="item">
                        <div class="question" (click)="item.open = !item.open">
                          @if (lang !== 'AR') {
                            <span>{{ item.question }}</span>
                          }
                          @if (lang === 'AR') {
                            <span>{{ item.questionAr }}</span>
                          }
                          <span class="fixed-space-8" aria-hidden="true"></span>
                          <popsy-icon-chevron-down
                            class="icon icon fill-gray-01"
                            [class.selected]="item.open" />
                        </div>
                        @if (lang !== 'AR') {
                          <div
                            class="answer"
                            [class.selected]="item.open"
                            [innerHTML]="item.answer"></div>
                        }
                        @if (lang === 'AR') {
                          <div
                            class="answer"
                            [class.selected]="item.open"
                            [innerHTML]="item.answerAr"></div>
                        }
                        @if (i === 1 && item.open) {}
                        <span class="line fill-row"></span>
                      </div>
                    }
                  }
                </div>
              </div>
            }
          </div>

          <span class="fixed-space-16" aria-hidden="true"></span>

          <!-- TABBY -->
          <div
            class="popsy-card option-card"
            [class.selected]="selectedTab() === 'tabby'">
            @if (lang !== 'AR') {
              <div
                class="cursor-pointer"
                (click)="
                  selectedTab() === 'tabby'
                    ? selectedTab.set(null)
                    : selectedTab.set('tabby')
                ">
                <div class="flex align-center justify-between">
                  <div class="flex align-center">
                    <popsy-checkbox
                      [checked]="selectedTab() === 'tabby'"
                      class="tabby"></popsy-checkbox>

                    <h1>Tabby</h1>
                  </div>
                  <popsy-icon-tabby class="icon provider"></popsy-icon-tabby>
                </div>
                <div
                  class="flex"
                  [class.flex-col]="(lessThan$ | async)?.mobileL === true"
                  [class.gap-4]="(lessThan$ | async)?.mobileL === true"
                  [class.gap-16]="!(lessThan$ | async)?.mobileL === true">
                  <span class="text-gray-05">Up to 4 installments </span>
                  <span class="text-gray-05"> A down payment of 25% </span>
                  <span class="text-gray-05"> From 200 SAR to 5,000 SAR </span>
                </div>
                <span class="fixed-space-8" aria-hidden="true"></span>
              </div>
            } @else {
              <div
                class="cursor-pointer"
                (click)="
                  selectedTab() === 'tabby'
                    ? selectedTab.set(null)
                    : selectedTab.set('tabby')
                ">
                <div class="flex align-center justify-between">
                  <div class="flex align-center">
                    <popsy-checkbox
                      [checked]="selectedTab() === 'tabby'"
                      class="tabby"></popsy-checkbox>

                    <h1>تابي</h1>
                  </div>
                  <popsy-icon-tabby-ar class="icon provider"></popsy-icon-tabby-ar>
                </div>
                <div
                  class="flex"
                  [class.flex-col]="(lessThan$ | async)?.mobileL === true"
                  [class.gap-4]="(lessThan$ | async)?.mobileL === true"
                  [class.gap-16]="!(lessThan$ | async)?.mobileL === true">
                  <span class="text-gray-05">حتى 4 أقساط </span>
                  <span class="text-gray-05">دفعة أولى بنسبة 25% </span>
                  <span class="text-gray-05">من 200 ريال سعودي إلى 5000 ريال سعودي </span>
                </div>
                <span class="fixed-space-8" aria-hidden="true"></span>
              </div>
            }

            @if (selectedTab() === 'tabby') {
              <div class="card-content">
                @if (lang !== 'AR') {
                  <span
                    >Tabby is a flexible payment method that gives you the security and
                    freedom to buy everything you need now and pay later or in
                    installments without any interest or added fees.
                  </span>
                } @else {
                  <span>
                    Tabby هي طريقة دفع مرنة تمنحك الأمان والحرية لشراء كل ما تحتاجه الآن
                    والدفع لاحقًا أو على أقساط دون أي فائدة أو رسوم إضافية.
                  </span>
                }

                <span class="fixed-space-16" aria-hidden="true"></span>

                @if (lang !== 'AR') {
                  <h3>How to buy with Tabby</h3>
                  <div class="flex flex-col">
                    <span>1. Choose to pay via Tabby on the checkout page </span>
                    <span>2. Split in 4 monthly payments </span>
                    <span
                      >3. Complete checkout and Tabby we’ll remind you when it's time to
                      pay.
                    </span>
                  </div>
                } @else {
                  <h3>كيفية الشراء مع Tabby</h3>
                  <div class="flex flex-col">
                    <span>اختر الدفع عبر Tabby على صفحة طرق الدفع </span>
                    <span>قم بتقسيم المبلغ على 4 دفعات شهرية </span>
                    <span>
                      أكمل عملية الدفع و Tabby كما سنذكرك عندما يحين وقت الدفع.
                    </span>
                  </div>
                }

                <span class="fixed-space-16" aria-hidden="true"></span>

                @if (lang !== 'AR') {
                  <h3>Eligibility</h3>

                  <span class="fixed-space-8" aria-hidden="true"></span>

                  <div
                    class="eligibility-grid"
                    [class.mobile]="(lessThan$ | async)?.mobileL === true">
                    <span class="bold">Age</span>
                    <span class="bold"> Eligibility </span>
                    <span class="bold">Minimum loan value </span>
                    <span class="bold">Maximum loan value </span>

                    <span>Below 18 years</span>
                    <span>Not eligible</span>
                    <span></span>
                    <span></span>

                    <span> 18 - 21 years </span>
                    <span>Eligible</span>
                    <span>SAR 200</span>
                    <span>SAR 1,500</span>

                    <span> Above 21 years </span>
                    <span> Eligible </span>
                    <span> SAR 200 </span>
                    <span> SAR 5,000 </span>
                  </div>
                } @else {
                  <h3>الأهلية</h3>
                  <span class="fixed-space-8" aria-hidden="true"></span>

                  <div
                    class="eligibility-grid"
                    [class.mobile]="(lessThan$ | async)?.mobileL === true">
                    <span class="bold"> العمر</span>
                    <span class="bold"> الأهلية </span>
                    <span class="bold"> الحد الأدنى للقرض </span>
                    <span class="bold"> الحد الأقصى للقرض </span>

                    <span>ما دون 18 سنة </span>
                    <span>غير مؤهل </span>
                    <span></span>
                    <span></span>

                    <span> 18 - 21 سنة </span>
                    <span>مؤهل</span>
                    <span>200 ريال سعودي</span>
                    <span>1500 ريال سعودي</span>

                    <span> فوق 21 سنة </span>
                    <span>مؤهل</span>
                    <span>200 ريال سعودي</span>
                    <span>5000 ريال سعودي</span>
                  </div>
                }

                <span class="fixed-space-16" aria-hidden="true"></span>

                @if (lang !== 'AR') {
                  <h3>Requirements</h3>
                  <span
                    >When registering at Tabby for the first time you will need to
                    provide:
                  </span>
                  <div class="flex flex-col">
                    <span>Valid mobile phone number</span>
                    <span> Copy of your national ID</span>
                    <span>Valid debit or credit card</span>
                  </div>
                } @else {
                  <h3>الشروط والمستندات المطلوبة:</h3>
                  <span>
                    عند تسجيل الدخول للمرة الأولى مع تابي سوف تحتاج إلى تقديم ما يلي:
                  </span>
                  <div class="flex flex-col">
                    <span>رقم هاتف محمول صالح </span>
                    <span>صورة عن هوية التعريف الشخصية </span>
                    <span>بطاقة دفع أو ائتمان صالحة للإستخدام </span>
                  </div>
                }

                <span class="fixed-space-16" aria-hidden="true"></span>

                <div class="faq">
                  @if (lang !== 'AR') {
                    <h3>FAQ</h3>
                  } @else {
                    <h3>الأسئلة الشائعة</h3>
                  }

                  @for (item of tabbyFaqData; track item; let i = $index) {
                    @if (
                      (lang !== 'AR' && item.question.length) ||
                      (lang === 'AR' && item.questionAr.length)
                    ) {
                      <div class="item">
                        <div class="question" (click)="item.open = !item.open">
                          @if (lang !== 'AR') {
                            <span>{{ item.question }}</span>
                          }
                          @if (lang === 'AR') {
                            <span>{{ item.questionAr }}</span>
                          }
                          <span class="fixed-space-8" aria-hidden="true"></span>
                          <popsy-icon-chevron-down
                            class="icon icon fill-gray-01"
                            [class.selected]="item.open" />
                        </div>
                        @if (lang !== 'AR') {
                          <div
                            class="answer"
                            [class.selected]="item.open"
                            [innerHTML]="item.answer"></div>
                        }
                        @if (lang === 'AR') {
                          <div
                            class="answer"
                            [class.selected]="item.open"
                            [innerHTML]="item.answerAr"></div>
                        }
                        @if (i === 1 && item.open) {}
                        <span class="line fill-row"></span>
                      </div>
                    }
                  }
                </div>
              </div>
            }
          </div>

          <span class="fixed-space-16" aria-hidden="true"></span>

          <!-- QUARA FINANCE -->
          @if (displayQuara() === true) {
            <div
              class="popsy-card option-card"
              [class.selected]="selectedTab() === 'quara'">
              @if (lang !== 'AR') {
                <div
                  class="cursor-pointer"
                  (click)="
                    selectedTab() === 'quara'
                      ? selectedTab.set(null)
                      : selectedTab.set('quara')
                  ">
                  <div class="flex align-center justify-between">
                    <div class="flex align-center">
                      <popsy-checkbox
                        [checked]="selectedTab() === 'quara'"
                        class="tabby"></popsy-checkbox>

                      <h1>Quara Finance</h1>
                    </div>
                    <popsy-icon-quara class="icon provider"></popsy-icon-quara>
                  </div>
                  <div
                    class="flex"
                    [class.flex-col]="(lessThan$ | async)?.mobileL === true"
                    [class.gap-4]="(lessThan$ | async)?.mobileL === true"
                    [class.gap-16]="!(lessThan$ | async)?.mobileL === true">
                    <span class="text-gray-05">From 6 to 36 months </span>
                    <span class="text-gray-05">No down payment </span>

                    <span class="text-gray-05">From 4,000 SAR up to 30,000 SAR </span>
                  </div>
                  <span class="fixed-space-8" aria-hidden="true"></span>
                </div>
              } @else {
                <div
                  class="cursor-pointer"
                  (click)="
                    selectedTab() === 'quara'
                      ? selectedTab.set(null)
                      : selectedTab.set('quara')
                  ">
                  <div class="flex align-center justify-between">
                    <div class="flex align-center">
                      <popsy-checkbox
                        [checked]="selectedTab() === 'quara'"
                        class="tabby"></popsy-checkbox>

                      <h1>الدفع عن طريق كوارا</h1>
                    </div>
                    <popsy-icon-quara-ar class="icon provider"></popsy-icon-quara-ar>
                  </div>
                  <div
                    class="flex"
                    [class.flex-col]="(lessThan$ | async)?.mobileL === true"
                    [class.gap-4]="(lessThan$ | async)?.mobileL === true"
                    [class.gap-16]="!(lessThan$ | async)?.mobileL === true">
                    <span class="text-gray-05">من 6 إلى 36 شهرًا</span>
                    <span class="text-gray-05">لا يوجد دفعة أولى </span>

                    <span class="text-gray-05"
                      >من 4000 ريال سعودي إلى 30000 ريال سعودي</span
                    >
                  </div>
                  <span class="fixed-space-8" aria-hidden="true"></span>
                </div>
              }

              @if (selectedTab() === 'quara') {
                <div class="card-content">
                  @if (lang !== 'AR') {
                    <h3>How to buy with Quara</h3>
                    <div class="flex flex-col">
                      <span>1. Select Quara as your payment method </span>
                      <span>2. Log in or sign up with your mobile number </span>
                      <span
                        >Verify your ID and required documents if it’s your first order
                        with Quara
                      </span>
                      <span
                        >4. Get the approval for your purchase and pay it over time
                      </span>
                    </div>
                  } @else {
                    <h3>كيفية الشراء عن طريق كوارا</h3>
                    <div class="flex flex-col">
                      <span>1. اختر كوارا كطريقة الدغع الخاصة بك </span>
                      <span
                        >2. قم بتسجيل الدخول أو إنشاء حساب باستخدام رقم الهاتف الخاص بك
                      </span>
                      <span
                        >3. قم بتعريف البطاقة الشخصية الخاصة بك والمستندات الأخرى المطلوبة
                        في حال كان هذا طلبك الأول لك مع كوارا
                      </span>
                      <span
                        >4. احصل على الموافقة على عملية الشراء خاصتك وادفع المبلغ المستحق
                        على أقساط
                      </span>
                    </div>
                  }

                  <span class="fixed-space-16" aria-hidden="true"></span>

                  @if (lang !== 'AR') {
                    <h3>Eligibility</h3>

                    <span
                      >Designed to serve citizens and residents, employees and retirees
                      alike, the service is available to all segments of the population.
                      The service will be provided based on your professional status, age,
                      service term, and net salary.
                    </span>
                    <span class="fixed-space-8" aria-hidden="true"></span>

                    <div
                      class="eligibility-grid"
                      [class.mobile]="(lessThan$ | async)?.mobileL === true">
                      <span class="bold"> Occupational Status </span>
                      <span class="bold">Age</span>
                      <span class="bold">Installment Plan</span>
                      <span class="bold">Net Salary</span>

                      <span> Governmental Employee </span>
                      <span> 21-60 Years </span>
                      <span>3 months</span>
                      <span>3,500</span>

                      <span>Military (Officers)</span>
                      <span>21 years old - by rank</span>
                      <span>6 months</span>
                      <span>3,500</span>

                      <span>
                        Military personnel rank (deputy sergeant / sergeant / first
                        sergeant / chief sergeant)</span
                      >
                      <span>21 years old - by rank</span>
                      <span>6 months </span>
                      <span>3,500</span>

                      <span>
                        Military personnel rank (Soldier / First Soldier / Corporal)
                      </span>
                      <span> 25 years old - by rank </span>
                      <span> 6 months </span>
                      <span> 3,500 </span>

                      <span> Private Sector Employees </span>
                      <span> 21- 60 Years</span>
                      <span>6 months </span>
                      <span>3,500</span>

                      <span> Retirees </span>
                      <span> Until 70 Years </span>
                      <span> None </span>
                      <span> 3,500 </span>

                      <span> Governmental Sector Employees - Residents </span>
                      <span> 25- 60 Years </span>
                      <span> 12 months </span>
                      <span> 3,500 </span>

                      <span> Private Sector Employees - Residents </span>
                      <span> 25- 60 Years </span>
                      <span> 6 months </span>
                      <span> 7,500 </span>
                    </div>
                  } @else {
                    <h3>الأهلية</h3>

                    <span
                      >تم تصميم هذه الخدمة لخدمة المواطنين والمقيمين والموظفين والمتقاعدين
                      على حد سواء، وهي متاحة لجميع شرائح السكان. سيتم تقديم الخدمة بناءً
                      على وضعك المهني وعمرك وفترة خدمتك والأجر الصافي.
                    </span>
                    <span class="fixed-space-8" aria-hidden="true"></span>

                    <div
                      class="eligibility-grid"
                      [class.mobile]="(lessThan$ | async)?.mobileL === true">
                      <span class="bold"> الوضع المهني </span>
                      <span class="bold"> العمر </span>
                      <span class="bold"> خطة الدفع على أقساط </span>
                      <span class="bold"> الأجر الصافي </span>

                      <span> الموظّف الحكومي </span>
                      <span>21 - 60 سنة</span>
                      <span>3 أشهر</span>
                      <span>3500</span>

                      <span> الضابط العسكري </span>
                      <span>21 سنة - حسب الرتبة العسكرية</span>
                      <span>6 أشهر</span>
                      <span>3500</span>

                      <span>
                        العسكري الرتبة العسكرية (ملازم - ملازم أول - نقيب - رائد)
                      </span>
                      <span>21 سنة - حسب الرتبة العسكرية</span>
                      <span>6 أشهر</span>
                      <span>3500</span>

                      <span> العاملون في القطاع الخاص </span>
                      <span>21 - 60 سنة</span>
                      <span>6 أشهر</span>
                      <span>3500</span>

                      <span> موظفي القطاع العام </span>
                      <span> 25 - 60 سنة </span>
                      <span>6 أشهر </span>
                      <span> 3500 </span>

                      <span> المتقاعدن </span>
                      <span>حتى 70 سنة</span>
                      <span>لا يوجد</span>
                      <span>3500</span>

                      <span> موظفي القطاع الحكومي المقيمين </span>
                      <span>25 - 60 سنة</span>
                      <span>12 شهراً</span>
                      <span>3500</span>

                      <span> موظفي القطاع الخاص المقيمين </span>
                      <span>25 - 60 سنة</span>
                      <span>6 أشهر</span>
                      <span>7500</span>
                    </div>
                  }

                  <span class="fixed-space-16" aria-hidden="true"></span>

                  @if (lang !== 'AR') {
                    <h3>Requirements</h3>
                    <div class="flex flex-col">
                      <span>Copy of personal ID </span>
                      <span>Account Statement for the last 3-month salary</span>
                      <span
                        >Salary breakdown and appointment date from the employer
                      </span>
                      <span
                        >The acceptance of application requires a credit record free of
                        defaults.
                      </span>
                    </div>
                  } @else {
                    <h3>الشروط والمستندات المطلوبة:</h3>
                    <div class="flex flex-col">
                      <span>صورة عن بطاقة الهوية الشخصية </span>
                      <span>بيان الحساب عن الراتب خلال الأشهر الثلاث الأخيرة </span>
                      <span>جدول توزيع الراتب وتاريخ التعيين من صاحب العمل </span>
                      <span>
                        يتطلب قبول الطلب سجلاً ائتمانياً خالياً من أي تخلّف سابق عن الدفع
                      </span>
                    </div>
                  }

                  <span class="fixed-space-16" aria-hidden="true"></span>

                  <div class="faq">
                    @if (lang !== 'AR') {
                      <h3>FAQ</h3>
                    } @else {
                      <h3>الأسئلة الشائعة</h3>
                    }

                    @for (item of quaraFaqData; track item; let i = $index) {
                      @if (
                        (lang !== 'AR' && item.question.length) ||
                        (lang === 'AR' && item.questionAr.length)
                      ) {
                        <div class="item">
                          <div class="question" (click)="item.open = !item.open">
                            @if (lang !== 'AR') {
                              <span>{{ item.question }}</span>
                            }
                            @if (lang === 'AR') {
                              <span>{{ item.questionAr }}</span>
                            }
                            <span class="fixed-space-8" aria-hidden="true"></span>
                            <popsy-icon-chevron-down
                              class="icon icon fill-gray-01"
                              [class.selected]="item.open" />
                          </div>
                          @if (lang !== 'AR') {
                            <div
                              class="answer"
                              [class.selected]="item.open"
                              [innerHTML]="item.answer"></div>
                          }
                          @if (lang === 'AR') {
                            <div
                              class="answer"
                              [class.selected]="item.open"
                              [innerHTML]="item.answerAr"></div>
                          }
                          @if (i === 1 && item.open) {}
                          <span class="line fill-row"></span>
                        </div>
                      }
                    }
                  </div>
                </div>
              }
            </div>
          }

          <span class="fixed-space-64" aria-hidden="true"></span>

          <h1>{{ t('label_preview_plan') }}</h1>
          <span class="fixed-space-8" aria-hidden="true"></span>

          <div class="popsy-card">
            <span class="">1. {{ t('label_installment_partner') }}</span>
            <span class="fixed-space-8" aria-hidden="true"></span>

            <nav class="flex gap-8 flex-wrap">
              @if (displayBaseeta() === true) {
                <div
                  class="popsy-card option-card calculator align-center p-8"
                  [class.selected]="selectedCalculator() === 'baseeta'"
                  (click)="selectedCalculator.set('baseeta')">
                  @if (lang !== 'AR') {
                    <popsy-icon-baseeta-badge-en class="icon provider" />
                  } @else {
                    <popsy-icon-baseeta-badge-ar class="icon provider" />
                  }
                </div>
              }

              <div
                class="popsy-card option-card calculator align-center p-8"
                [class.selected]="selectedCalculator() === 'tamara'"
                (click)="selectedCalculator.set('tamara')">
                @if (lang !== 'AR') {
                  <popsy-icon-tamara class="icon provider" />
                } @else {
                  <popsy-icon-tamara-ar class="icon provider" />
                }
              </div>

              <div
                class="popsy-card option-card calculator align-center p-8"
                [class.selected]="selectedCalculator() === 'tabby'"
                (click)="selectedCalculator.set('tabby')">
                @if (lang !== 'AR') {
                  <popsy-icon-tabby class="icon provider" />
                } @else {
                  <popsy-icon-tabby-ar class="icon provider" />
                }
              </div>

              @if (displayQuara() === true) {
                <div
                  class="popsy-card option-card calculator align-center p-8"
                  [class.selected]="selectedCalculator() === 'quara'"
                  (click)="selectedCalculator.set('quara')">
                  @if (lang !== 'AR') {
                    <popsy-icon-quara class="icon provider" />
                  } @else {
                    <popsy-icon-quara-ar class="icon provider" />
                  }
                </div>
              }
            </nav>

            <app-installments-calculator
              [currency]="currency || 'SAR'"
              [amount]="calculatorAmount()"
              [maxInstallments]="selectedMaxInstallments()"
              class="calculator" />
          </div>

          <span class="fixed-space-32" aria-hidden="true"></span>

          <app-other-topics></app-other-topics>

          <span class="fixed-space-64" aria-hidden="true"></span>
        </section>
      </article>
      @if ((lessThan$ | async)?.mobileL !== true) {
        <span class="fixed-space-64" aria-hidden="true"></span>
      }
      @if (!(inFullScreenMode$ | async)) {
        <app-footer
          class="footer"
          [class.phone]="(lessThan$ | async)?.mobileL"></app-footer>
      }
    </div>
  </div>
</main>
